<template>
  <div class="authorize_page">
    <div class="page_header">
      <div class="logo_box">
        <img src="/static/images/LOGO.png" />
      </div>
      <p>汇信网</p>
    </div>
    <div class="page_container">
        <div class="title">您可以通过以下两个步骤向法定代表人申请办理信用培训事项：</div>
        <div class="content">
            <div class="first_step">
                <p>第一步：点击<b>【复制授权链接】</b>按钮复制授权链接</p>
                <div class="copy_btn" @click="copyText">复制授权链接</div>
            </div>
            <div class="second_step">
                <p>第二步：<b>关闭</b>本页面后将复制的链接<b>通过微信发</b>送给法定代表人</p>
            </div>
        </div>
        
    </div>
    
  </div>
</template>

<script>
export default {
  name: "authorize",
  data() {
    return {
      userName: "",
      enterpriseName: "",
      sqnr: "",
      squrl: "",
      userId: "",
      qyId: "",
      token: "",
    };
  },
  created() {
    this.qyId = this.getQueryVariable("qyId");
    this.userId = this.getQueryVariable("userId");
    this.token = decodeURI(this.getQueryVariable("token"));
  },
  mounted() {
    this.getQRCode();
  },

  methods: {
    //复制
    copyText() {
      let message = `${this.enterpriseName}(${this.userName})正在申请'${this.sqnr}'的授权，您可在线审批他的授权申请。点击链接去审批：${this.squrl}`;
      this.$copyText(message)
        .then((res) => {
          this.$notify({ title: '成功', type: "success", message: "复制成功", showClose: false, });
        })
        .catch((err) => {
          this.$notify({ title: '错误', type: "warning", message: "复制失败", showClose: false, });
        });
    },
    //获取要授权信息
    getQRCode: function () {
      let formdata1 = new FormData();
      formdata1.append("userId", this.userId);
      formdata1.append("qyId", this.qyId);

      let ajax = this.$http.create();
      ajax({
        method: "post",
        url: SOWINURL + "index/getAuthorizationURL",
        headers: {
          token: this.token
        },
        data: formdata1,
      })
        .then((res) => {
          let resData = res.data;
          if (resData.result == 200) {
            let qrData = resData.data;
            this.userName = qrData.userName;
            this.enterpriseName = qrData.enterpriseName;

            let sqnr = qrData.qyfwnr;
            this.sqnr =
              sqnr == 0 ? "培训" : sqnr == 1 ? "信用报告" : "培训+信用报告";

            this.squrl = qrData.sqUrl;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //截取链接参数
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
  },
};
</script>

<style scoped lang="less" type="text/less">
.authorize_page {
  min-height: 100vh;
  background-color: #fff;
  font-size: 15px;
  padding: 0 20px;
  box-sizing: border-box;
  .page_header {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px 0;
    box-sizing: border-box;
    border-bottom: 1px #f5f8fa solid;
    .logo_box {
        width: 100px;
        height: 100px;
        background-color: #f5f8fa;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
      img {
        display: block;
        height: 18px;
      }
    }
    p {
      margin-top: 15px;
      font-size: 20px;
      font-weight: bold;
    }
  }
  .page_container{
      padding: 30px 0;
      box-sizing: border-box;
      .title{
          font-weight: bold;
      }
      .content{
          margin-top: 20px;
          font-size: 14px;
          line-height: 1.6;
          .first_step{
              .copy_btn{
                  margin-top: 15px;
                  display: inline-block;
                  padding: 10px 20px;
                  border: 1px #409EFF solid;
                  border-radius: 10px;
                  color: #409EFF;
                  
              }
          }
          .second_step{
              margin-top: 20px;
          }
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/authorize.vue